<template>
  <div ref="load-on-scroll" class="tac t-gray py-3">
    <!-- empty haha -->
  </div>
</template>

<script>
import { clearTimeout } from 'timers';
import { clone } from '@/helpers/utils';

// 
export default {
  name: 'loadOnScroll',
  components: {},
  props: [
    'fn_load_data',
    'status_no_more_data',
  ],
  data() {
    return {
      timer: null,

      mark_st_last_ajax: 0,
    }
  },
  computed: {},
  watch: {},
  methods: {

    checkDomPosition(){
      let v = this

      let h_screen = document.documentElement.clientHeight
      let h_scrolltop = parseInt(document.documentElement.scrollTop)
      let h_el = v.$refs['load-on-scroll'].offsetTop

      let mark = (h_screen + h_scrolltop) > (h_el - 100)

      // console.log('====gagaga...',h_screen,h_scrolltop,h_el,mark)

      if(mark && v.fn_load_data  && !v.status_no_more_data){
        let st_now = (new Date()).valueOf()
        if( st_now - v.mark_st_last_ajax <= 300){
          console.log('loadOnScroll - returned.')
          return
        }
        v.mark_st_last_ajax = st_now
        v.fn_load_data()
      }

    },

    scrollHandlerDebounce(){
      let v = this

      if(v.timer){
        // console.log('clearTimeout')
        window.clearTimeout(v.timer)
        v.timer = null
      }

      // console.log('new timer')
      v.timer = window.setTimeout(v.checkDomPosition,500)
    },

    run(){
      window.removeEventListener('scroll',this.scrollHandlerDebounce)
      window.addEventListener('scroll',this.scrollHandlerDebounce)
    },
  },
  created() {
    this.run()
  },
  //mounted() {},
  beforeDestroy() {
    window.removeEventListener('scroll',this.scrollHandlerDebounce)
  },
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>